import { Home } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function FloatingBackButton({ showHome = true }) {
  const navigate = useNavigate();

  // Only show Home button now
  if (!showHome) return null;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <Button
        onClick={() => navigate('/dashboard')}
        className="rounded-full shadow-lg bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white px-6 py-3 h-12"
        data-testid="floating-home-btn"
      >
        <Home className="w-5 h-5 mr-2" />
        Home
      </Button>
    </div>
  );
}
